import { Mail, MessageCircle, Share2, Smartphone, type LucideIcon } from 'lucide-react';
import type { AutomationGuards, GuardChannel } from '@/types';

/** Mirrors kim-ai-backend automationGuards.utils.ts: the behaviour before guards were configurable. */
export const DEFAULT_AUTOMATION_GUARDS: AutomationGuards = {
	humanReplyExemptChannels: ['chat'],
	botReplyAllowance: {},
	novelIntentAutoSend: false,
	holdMessage: { enabled: false, delaySeconds: 8, text: '' },
	multiIntentAutoSend: false,
	relevancyJudgeEnabled: true,
	resolutionConsistencyCheck: true,
	assistedThreshold: 0.5,
	autoSendOnResolvedTickets: false,
	operatingHoursFailOpen: true,
	emailReplyDelay: { enabled: false, minMinutes: 2, maxMinutes: 5 }
};

export const GUARD_CHANNELS: { id: GuardChannel; label: string }[] = [
	{ id: 'email', label: 'Email' },
	{ id: 'chat', label: 'Chat' },
	{ id: 'sms', label: 'SMS' },
	{ id: 'social', label: 'Social' }
];

export const MAX_BOT_REPLY_ALLOWANCE = 20;
export const MIN_HOLD_MESSAGE_DELAY_SECONDS = 3;
export const MAX_HOLD_MESSAGE_DELAY_SECONDS = 60;
export const MAX_HOLD_MESSAGE_TEXT_CHARS = 200;
/** Mirrors kim-ai-backend MAX_EMAIL_REPLY_DELAY_MINUTES. */
export const MAX_EMAIL_REPLY_DELAY_MINUTES = 120;

/** Icon per channel; `livechat` is how some helpdesks name chat. */
export const CHANNEL_ICONS: Record<string, LucideIcon> = { email: Mail, chat: MessageCircle, livechat: MessageCircle, sms: Smartphone, social: Share2 };
